// Vigencia sugerida por ítem del Checklist (bloque 5b, F). Las fechas siguen
// siendo MANUALES: esto solo llena "Vigente hasta" cuando está vacío, y el
// usuario la puede cambiar. Base: AM MDT-2024-196 (R.O. 4.º Supl. 691,
// 26/11/2024, sin reformas) Art. 20, 13, 15 y 22; DE 255 Art. 39; CT Art. 434.

export type ReglaVigencia =
  | { meses: number; cita: string }
  | { hasta31EneroSiguiente: true; cita: string };

const RESPONSABLES = 'AM 196 Art. 20, responsables SST';
const PROGRAMAS    = 'AM 196 Art. 20';

export const VIGENCIAS_SSO: Record<string, ReglaVigencia> = {
  'GA-01': { meses: 12, cita: 'AM 196 Art. 20' },
  'GA-02': { meses: 24, cita: 'AM 196 Art. 20; CT Art. 434' },
  'GA-04': { meses: 12, cita: RESPONSABLES },
  'GA-05': { meses: 12, cita: RESPONSABLES },
  'GA-06': { meses: 12, cita: RESPONSABLES },
  'GA-08': { meses: 12, cita: RESPONSABLES },
  'GA-09': { meses: 24, cita: 'AM 196 Arts. 20 y 22' },
  'GA-10': { meses: 24, cita: 'AM 196 Arts. 20 y 22' },
  'GA-07': { meses: 1,  cita: 'AM 196 Arts. 13 y 15, informe mensual' },
  'GA-11': { hasta31EneroSiguiente: true, cita: 'DE 255 Art. 39' },
  // Programas del Art. 20 (empleadores con más de 10 trabajadores).
  'TH-08': { meses: 12, cita: PROGRAMAS }, // Programa de formación y capacitación (plan anual)
  'PO-16': { meses: 12, cita: PROGRAMAS }, // Plan de emergencias (amenazas naturales y riesgos antrópicos)
  'PO-24': { meses: 12, cita: PROGRAMAS }, // Programa de prevención de riesgo psicosocial
  'PO-25': { meses: 12, cita: PROGRAMAS }, // Registro del programa psicosocial en SUT
  'PO-26': { meses: 12, cita: PROGRAMAS }, // Programa de alcohol, tabaco y drogas
  'PO-27': { meses: 12, cita: PROGRAMAS }, // Registro del programa de alcohol y drogas en SUT
};

/** Suma meses a una fecha YYYY-MM-DD; si el día no existe en el mes final, usa el último día. */
export function sumarMeses(fecha: string, meses: number): string {
  const [a, m, d] = fecha.split('-').map(Number);
  const total = (m - 1) + meses;
  const anio = a + Math.floor(total / 12);
  const mes = ((total % 12) + 12) % 12;
  const ultimo = new Date(Date.UTC(anio, mes + 1, 0)).getUTCDate();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${anio}-${pad(mes + 1)}-${pad(Math.min(d, ultimo))}`;
}

/** "Vigente hasta" sugerido para el ítem a partir de "Aprobado desde", o null si no hay regla. */
export function vigenciaSugerida(itemId: string, aprobadoDesde: string): { fecha: string; cita: string } | null {
  const regla = VIGENCIAS_SSO[itemId];
  if (!regla || !/^\d{4}-\d{2}-\d{2}$/.test(aprobadoDesde)) return null;
  if ('meses' in regla) return { fecha: sumarMeses(aprobadoDesde, regla.meses), cita: regla.cita };
  return { fecha: `${Number(aprobadoDesde.slice(0, 4)) + 1}-01-31`, cita: regla.cita };
}

export function textoSugerencia(cita: string): string {
  return `Sugerido según ${cita}. Puedes cambiarlo.`;
}

export interface FechasConItem { checklist_item_id: string; approved_from: string; expiry_date: string }

/**
 * Llena "Vigente hasta" con la sugerencia cuando está vacío o cuando lo llenó
 * StorSafe (auto = true) y cambió el ítem o "Aprobado desde". Una fecha que
 * escribió el usuario (auto = false) no se toca.
 */
export function aplicarVigenciaSugerida<F extends FechasConItem>(f: F, auto: boolean): { form: F; auto: boolean; nota: string } {
  if (f.expiry_date && !auto) return { form: f, auto: false, nota: '' };
  const s = vigenciaSugerida(f.checklist_item_id, f.approved_from);
  if (s) return { form: { ...f, expiry_date: s.fecha }, auto: true, nota: textoSugerencia(s.cita) };
  return { form: auto ? { ...f, expiry_date: '' } : f, auto: false, nota: '' };
}
